import React, { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  Theme,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material';
import { ExpandMore, Edit, Delete } from '@mui/icons-material';
import { IChecklistTemplate } from '../../../models';

interface IMobileChecklist {
  original: IChecklistTemplate;
  handleEdit: (val: IChecklistTemplate) => void;
  handleDelete: (val: IChecklistTemplate) => void;
}

export const MobileChecklist: FC<IMobileChecklist> = ({ original, handleEdit, handleDelete }) => {
  const classes = useStyles();
  const { name, type, sageTaskId } = original;
  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{name}</Typography>
          <div className={classes.buttonsWrapper}>
            <IconButton
              className={classes.editButton}
              color="primary"
              onClick={e => {
                e.stopPropagation();
                handleEdit(original);
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              className={classes.deleteButton}
              color="primary"
              onClick={e => {
                e.stopPropagation();
                handleDelete(original);
              }}
            >
              <Delete />
            </IconButton>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Name:
          </FormLabel>
          <Typography component="span" variant="body2">
            {name || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Type:
          </FormLabel>
          <Typography component="span" variant="body2">
            {type || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Task ID:
          </FormLabel>
          <Typography component="span" variant="body2">
            {sageTaskId || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
